<ion-app>
  <app-loader></app-loader>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
